"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What products does Evermark Industrial Solutions make?",
  answer: "Evermark Industrial Solutions manufactures nine families of custom engraved products — phenolic legend plates, engraved nameplates, arc flash labels, electrical panel schedules, cable and wire ID tags, pipe and conduit markers, lockout/tagout tags, pushbutton legend plates, and MIL-SPEC phenolic."
}, {
  question: "Are these products in stock, or made to order?",
  answer: "Evermark Industrial Solutions manufactures engraved products to order from the specified material, size, color, and mounting; standard configurations are quoted and produced quickly, and a proof is approved before production."
}, {
  question: "Can I order a custom size or material not shown?",
  answer: "yes — Evermark Industrial Solutions quotes custom sizes, materials, and layouts through its custom engraving service; upload a file or describe the item on the quote page."
}, {
  question: "What's the minimum order?",
  answer: "minimum order quantity depends on the product and material; Evermark Industrial Solutions quotes single pieces and short runs as well as recurring programs — use {{verify: minimum order policy}}."
}, {
  question: "Do products meet electrical or safety codes?",
  answer: "Evermark Industrial Solutions produces products designed to align with standards such as UL 508A, NFPA 70E, ANSI Z535, and OSHA 1910.147 when properly specified; compliance depends on the application and field conditions, so Evermark recommends confirming requirements with the engineer of record or a qualified specialist."
}];
export default function Faq() {
  return <section id="faq" className="bg-accent text-accent-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-default tracking-tight">
            Engraved Products — Common Questions
          </h2>
        </div>

        <div className="mx-auto max-w-3xl">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/20">
                <AccordionTrigger className="text-left text-lg font-semibold font-default hover:text-primary transition-colors py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-base leading-relaxed text-accent-foreground/80 pb-6 font-sans">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}